import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Themes } from './components/Themes';
import { Process } from './components/Process';
import { Packages } from './components/Packages';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { useSiteMetadata } from './hooks/useSiteMetadata';
export function App() {
  useSiteMetadata();
  return <div className="min-h-screen flex flex-col font-sans text-soft-dark bg-soft-cream selection:bg-[#E8C3B3] selection:text-[#6B5E57] overflow-x-hidden" data-id="element-0" data-mp="2mm2mmgzj8x4h">
      <Header data-id="element-1" data-mp="31c9uk2rwyxqx" />

      <main className="flex-grow" data-id="element-2" data-mp="31ctfztgrw49p">
        <Hero data-id="element-3" data-mp="2wjgqzi86lvgf" />
        <Themes data-id="element-4" data-mp="2wjql9i09eorx" />
        <Process data-id="element-5" data-mp="2wj8evsjvuu6a" />
        <Packages data-id="element-6" data-mp="2wip6p3k1bk5g" />
        <About data-id="element-7" data-mp="2wi5qbra193tj" />
        <Contact data-id="element-8" data-mp="28u5ysp4wd9dw" />
      </main>

      <Footer data-id="element-9" data-mp="28te3zgj4jfoo" />
    </div>;
}